"use client";

import React from "react";
import { FiBox, FiArrowRight } from "react-icons/fi";
import styles from "./CardList.module.css";
import { useBlocks } from "./useBlocks";
import BlockCard from "./BlockCard";
import BlockCardSkeleton from "./BlockCardSkeleton";

const LatestBlocks: React.FC = () => {
  const { blocks, isFirstLoad, newItemId } = useBlocks();

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h3 className={styles.title}><FiBox size={18} /> Latest blocks</h3>
        <a href="/blocks" className={styles.viewAll}>
          View all blocks <FiArrowRight size={14} />
        </a>
      </div>
      <div
        className={`${styles.cardList} ${isFirstLoad ? "" : styles.fadeIn}`}
      >
        {blocks.length > 0
          ? blocks.map((block) => (
              <BlockCard
                key={block.height}
                block={block}
                isNew={block.height === newItemId}
              />
            ))
          : Array.from({ length: 3 }).map((_, i) => (
              <BlockCardSkeleton key={i} />
            ))}
      </div>
    </div>
  );
};

export default LatestBlocks;
